import { useEffect, useState } from "react";

import { useCartServiceApi } from "@/api/hooks/cartService.hook";

import GiftCardRequestBalance from "./giftCardRequestBalance.component";

const GIFT_CARD_NUMBER_SEARCH_PARAM = "giftCardNumber";

const GiftCardRequestBalanceContainer = () => {
    const [urlGiftCardNumber, setUrlGiftCardNumber] = useState<string>("");

    const [{ data: info, error, loading }, get] = useCartServiceApi(
        {
            url: "/giftcards/:number/balance",
            method: "GET"
        },
        {
            manual: true
        }
    );

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const giftCardNumber = new URLSearchParams(location?.search).get(
            GIFT_CARD_NUMBER_SEARCH_PARAM
        );

        if (giftCardNumber) {
            setUrlGiftCardNumber(giftCardNumber);
        }
    }, [setUrlGiftCardNumber]);

    const onRequestBalanceFor = (giftCardNumber: string, recaptcha: string) => {
        get({
            urlParams: {
                number: giftCardNumber
            },
            params: {
                recaptcha
            }
        });
    };

    return (
        <GiftCardRequestBalance
            key={urlGiftCardNumber}
            onRequestBalanceFor={onRequestBalanceFor}
            initialGiftCardNumber={urlGiftCardNumber}
            info={info}
            error={error}
            loading={loading}
        />
    );
};

export { GiftCardRequestBalanceContainer };
